import moment from 'moment';
import {FilterPredicate} from 'src/hooks/filtered-data/filter-predicate';
import {DateRange} from 'src/hooks/filtered-data/typedefs';

export class DateFilterPredicate<T> implements FilterPredicate<T> {

    // eslint-disable-next-line no-useless-constructor
    constructor(
        private readonly dateExtractor: (row: T) => string | null | undefined,
        private readonly filterValue: DateRange,
    ) {
    }

    isActive(): boolean {
        return Boolean(this.filterValue?.from || this.filterValue?.to);
    }

    check(row: T): boolean {
        const date = this.dateExtractor(row);

        return !!date && moment(date)
            .startOf('day')
            .isBetween(this.filterValue.from, this.filterValue.to, 'day', '[]');
    }
}
